module.exports = __webpack_public_path__ + "static/media/statistics.3ac93e6f.jpg";